import axios from "axios";

import { store } from "./store";

var client = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
});

client.vue_login = function () {
  if (store.getters.logged) {
    this.defaults.headers["Authorization"] = store.getters.token;
  }
};

export default client;
